module.exports = __webpack_public_path__ + "static/media/crutch.25a4506b.svg";